document.addEventListener("DOMContentLoaded", () => {

    // HEADER MEGA MENU
    let navLinkAll = document.querySelectorAll('.details_headermenu');
    let megaMenuOverlay = document.querySelector('.header_mega_menu_overlay');
    // let headerAndAnnounc = document.querySelector('.header_wrapper');

    function megaMenuFuntion() {
        let isAnyMenuActive = false; // Flag to track active menus
        navLinkAll.forEach(function (navLink) {
            let megeMenuActive = navLink.getAttribute('open');
            if (megeMenuActive === 'true') {
                isAnyMenuActive = true; // At least one menu is active
            }
        });
        if (isAnyMenuActive) {
            megaMenuOverlay.classList.add('header_mega_menu_overlay_active');
        } else {
            megaMenuOverlay.classList.remove('header_mega_menu_overlay_active');
        }
    }
    setInterval(megaMenuFuntion, 300);


    // ANNOUNCMENT SLIDER
    const mediaQuery = window.matchMedia('(max-width: 750px)')
    if (mediaQuery.matches) {
        $('.announcement_bar_wrapper .utility-bar__grid').slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            adaptiveHeight: true,
            dots: false,
            prevArrow:
                '<span class="Arrowleft slide_arrow"><svg width="14" height="28" viewBox="0 0 14 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.25 26.6667L0.75 14.1667L13.25 1.66675" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
            nextArrow:
                '<span class="ArrowRight slide_arrow"><svg width="14" height="28" viewBox="0 0 14 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 26.6667L13.25 14.1667L0.75 1.66675" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
        });

        $('.ship_ast_icon_txt.ship_icon_data_div').slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            adaptiveHeight: true,
            dots: false,
            prevArrow:
                '<span class="Arrowleft slide_arrow"><svg width="14" height="28" viewBox="0 0 14 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.25 26.6667L0.75 14.1667L13.25 1.66675" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
            nextArrow:
                '<span class="ArrowRight slide_arrow"><svg width="14" height="28" viewBox="0 0 14 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 26.6667L13.25 14.1667L0.75 1.66675" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
        });
    }


});


// VTO module js starts

const onSnapshot = function (data) {
    // this will display the image

    let container = document.querySelector('.vto__photo-container');
    let img = document.createElement("img");
    img.src = data.dataUrl;
    container.appendChild(img);

    setTimeout(function () {
        img.remove();
        downloadImage(data);
    }, 3000);
}

const downloadImage = function (data) {
    var a = document.createElement('a');
    a.href = data.dataUrl;
    a.download = "tryon.png";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}


let defaultFrameUpc = document.querySelector(".product_option_frame_color .product_option_values_grid .product_option__value")?.getAttribute("data-upc");

var params = {
    apiKey: 'EdScG4Kh0ODgiyM6fWdP1hqRVLNICEmuaLUXI0m0',
    frame: defaultFrameUpc,
    onStopVto: hide,
    onSnapshot: onSnapshot,
    onIssue: (data) => {
        console.log(data);
    },
};

window.onload = function () {
    if (document.getElementById("fitmix-container")) {
        window.fitmixInstance = FitMix.createWidget('fitmix-container', params, function () {
            // console.log('VTO module is ready.');
        });
    }
}

const fitmix = document.getElementById("fitmix-container")
const closeBtn = document.querySelector(".itg-close");
const photoBtn = document.querySelector(".photo_btn");
const measureBtn = document.getElementById("start-measurement");

function hide() {
    fitmix.style.display = 'none';
    closeBtn.style.display = 'none';
    photoBtn.style.display = 'none';
    measureBtn.style.display = 'block';
}

function show() {
    fitmix.style.display = 'block';
    measureBtn.style.display = 'none';
    setTimeout(() => {
        closeBtn.style.display = 'block';
        photoBtn.style.display = 'block';

    }, 500);
}

function openVto() {
    fitmixInstance.startVto('live')
    show()
}

function stopVto() {
    fitmixInstance.stopVto()
}
function takePhoto() {
    fitmixInstance.getSnapshot();
}
// VTO module js ends

//PD measurement

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("#start-measurement").forEach(function (elem) {
        // console.log(elem) ;
        elem.addEventListener("click", function (e) {
            e.preventDefault();
            let container = document.getElementById("msrt-container");
            container.style.display = "block"; // Show container

            Msrt.createWidget("msrt-container", {
                apiKey: "jj3o2RTT9uRvNoVbtnFDx2q1vuCjHDTmrxmHlDRo",
                pdCopyClipboard: true,
                onGetResultPd: (result) => {
                    // console.log('Pupillary Distance:', result.pd);
                    // console.log('Left PD:', result.left);
                    // console.log('Right PD:', result.right);
                    alert(`PD: ${result.pd}, Left: ${result.left || 'N/A'}, Right: ${result.right || 'N/A'}`);
                },
                onTooManyErrors: () => {
                    //console.log("User faced too many errors.");
                    alert("Too many errors occurred. Please try again.");
                },
                onClose: () => {
                    // console.log("PD Measurement closed.");
                    container.style.display = "none"; // Hide container
                },
                darkMode: true,
                disableNpsRating: true,
            });
        });

    })


});



// local storage js

// ============ ************* CHANGED --------------

// if (window.location.pathname.includes("/collections/replacement-lenses") || (window.location.pathname.includes("/pages/ordering-replacement-lenses")) ) {
//     localStorage.setItem("hideReplacementDataOptions", "true");
// } else if (window.location.pathname.includes("/collections/prescription-sunglasses") || (window.location.pathname === "/")) {
//     localStorage.removeItem("hideReplacementDataOptions");
// }

if (window.location.pathname.includes("replacement")) {
    localStorage.setItem("hideReplacementDataOptions", "true");
} else {
    localStorage.removeItem("hideReplacementDataOptions");
}

// ============ ************* CHANGED --------------


document.addEventListener("DOMContentLoaded", function () {
    const currentPage = window.location.pathname;
    const previousPage = sessionStorage.getItem("previousPage");

    sessionStorage.setItem("previousPage", currentPage);
    // ============ ************* CHANGED --------------
    // if (currentPage.includes("/collections/replacement-lenses") || currentPage.includes("/pages/ordering-replacement-lenses")) {
    //   localStorage.setItem("hideReplacementDataOptions", "true");
    // }

    // if (
    //   currentPage.includes("/collections/prescription-sunglasses") || 
    //   currentPage === "/" || 
    //   currentPage.includes("/pages/virtual-try-on") // Remove localStorage when visiting Virtual Try-On page
    // ) {
    //   localStorage.removeItem("hideReplacementDataOptions");
    // }
    // ============ ************* CHANGED --------------
    if (currentPage.includes("replacement")) {
        localStorage.setItem("hideReplacementDataOptions", "true");
    }
    else {
        localStorage.removeItem("hideReplacementDataOptions");
    }


});


// ============ ************* CHANGED --------------

// document.querySelectorAll(".nav_summary_childlinks .nav_summary_items .header_menus_items").forEach(function (elem) {
//   elem.addEventListener("click", function (e) {
//     let parentMenu = e.target.closest(".nav_detail_menus");
//     if (parentMenu) {
//       let summaryLink = parentMenu.querySelector("summary.main_check_title a.full-unstyled-link");
//       if (summaryLink && summaryLink.textContent.trim() === "Replacement Lenses") {
//         localStorage.setItem("hideReplacementDataOptions", "true");
//       }else
//           localStorage.removeItem("hideReplacementDataOptions");
//     }
//   });
// });
// ============ ************* CHANGED --------------


// show lens image on Search page  -----------
const searchPageCard = document.querySelectorAll('.template-search__results .product-card-wrapper');
if (searchPageCard && searchPageCard?.length > 0) {
    searchPageCard.forEach(element => {
        if (element.querySelector('.card__product-title > a').textContent.toLowerCase().trim().includes('replacement')) {
            const mainImgElement = element.querySelector('.card_replacement_images')
            let replacementImage = mainImgElement.getAttribute('data-replacementimage');
            let imageElement = mainImgElement.querySelector('img');
            if (imageElement && replacementImage) {
                imageElement.src = replacementImage;
                imageElement.srcset = replacementImage;
            }
        }
    });
}

// Collection products grid image change
if (localStorage.getItem("hideReplacementDataOptions")) {
    document.querySelectorAll('.card_replacement_images').forEach(element => {
        let replacementImage = element.getAttribute('data-replacementimage');
        let imageElement = element.querySelector('img');
        if (imageElement && replacementImage) {
            imageElement.src = replacementImage;
            imageElement.srcset = replacementImage;
        }
    });
    document.querySelector(".itg_main_product_temp").classList.add("collection_replacement_localdata");
}

let isProductPage = window.location.pathname.includes("/products/");
if (isProductPage) {
    let imgElement = document.querySelector('.customize_main_product_wrapper .Cookie_lenseimage .product-media-container .product__media.media img');
    let lensImg = document.querySelector(".product_option_values_grid.lense--option_value .product_option__value").getAttribute("data-lensimage");

    if (localStorage.getItem("hideReplacementDataOptions")) {

        imgElement.src = lensImg;
        imgElement.srcset = lensImg;

        document.querySelectorAll('.non_replacement_pro_price').forEach(el => {
            el.remove();
        });

    } else {
        document.querySelectorAll('.replacement_pro_price').forEach(el => {
            el.remove();
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    let isProductPage = window.location.pathname.includes("/products/");

    if (isProductPage) {
      sessionStorage.setItem("visitedProductPage", "true");
    }

    if (localStorage.getItem("hideReplacementDataOptions")) {

      if(!document.querySelector('body.product--page.template--replacement-product')) {
        if (document.querySelector(".wrapper.itg-vto")) document.querySelector(".wrapper.itg-vto").style.display = "none";
        if (document.querySelector(".thumbnail-slider")) document.querySelector(".thumbnail-slider").style.display = "none";
        let mediaList = document.querySelector(".product__column-sticky .slider-mobile-gutter .product__media-list");
        if (mediaList) {
          let listItems = mediaList.querySelectorAll(".product__media-item");
          if (window.innerWidth <= 750) {
            listItems.forEach((li, index) => {
              li.style.display = index === 0 ? "flex" : "none";
            });
          }
        }
        
      }

      let prodDetails = document.querySelectorAll(".produc_details_grid .produc_details_title_item");
      Array.from(prodDetails).reduce((_, singleProd) => {
        if (singleProd.getAttribute('product-details-title') === "frame-specs") {
          singleProd.style.display = "none";
        }
      }, null);

      // let mediaList = document.querySelector(".product__column-sticky .slider-mobile-gutter .product__media-list");
      // if (mediaList) {
      //   let listItems = mediaList.querySelectorAll(".product__media-item");
      //   if (window.innerWidth <= 750) {
      //     listItems.forEach((li, index) => {
      //       li.style.display = index === 0 ? "flex" : "none";
      //     });
      //   }
      // }

      // Lens image change JS
      document.querySelectorAll('.replacement_localdata .customize_main_product_wrapper .product_option_brand_lens_content.produc_brand_option_active ul li').forEach(function (item) {
        item.addEventListener('click', function () {
          document.querySelector(".nonreplacement_localdata .frameimage_list").style.display = "none";
          document.querySelector(".nonreplacement_localdata .no_frameimage_list").style.display = "flex";
          let lensImage = this.getAttribute('data-lensimage');
          let imageElement = document.querySelector('.customize_main_product_wrapper .Cookie_lenseimage .product-media-container .product__media.media img');
          if (imageElement) {
            imageElement.src = lensImage;
            imageElement.srcset = lensImage;
          }
        });
      });

      // Lens image change JS    
      if (document.querySelector(".product_option_frame_color")) {
        document.querySelector(".product_option_frame_color").style.display = "none";
        document.querySelector(".product_option_frame_color").nextElementSibling.style.setProperty("display", "none", "important");
        document.querySelector(".product_option_frame_color .product_option_values_grid").classList.remove("required_field");
      }
      //   if (document.querySelector("li.price_breakdown.price_breakdown_frame")) document.querySelector("li.price_breakdown.price_breakdown_frame").style.display = "none";
      if (document.querySelector(".itg_main_product_temp")) {
        document.querySelector(".itg_main_product_temp").classList.add("replacement_localdata");
        document.querySelector(".itg_main_product_temp").classList.remove("nonreplacement_localdata");
      }

      document.querySelectorAll('.product_option_frame_color .product_option_values_grid.itg_price_cal').forEach(el => el.removeAttribute('data-mainprice'));


      // Lens price show

      let firstLi = document.querySelector(".customize_main_product_wrapper ul.option_values_grid_three li:first-child");
      let main_symbol = document.querySelector('.itg_main_product_temp').getAttribute('data-sym');
      if (firstLi) {
        let priceValue = firstLi.getAttribute("data-currlensprice");
        let priceElements = document.querySelectorAll(".replacement_pro_price");
        priceElements.forEach(priceDiv => {
          priceDiv.textContent = main_symbol + priceValue; // Update all occurrences
        });
      }

    }
    else {
      if (document.querySelector(".wrapper.itg-vto")) document.querySelector(".wrapper.itg-vto").style.display = "block";
      if (document.querySelector(".thumbnail-slider")) document.querySelector(".thumbnail-slider").style.display = "block";

      let prodDetails = document.querySelectorAll(".produc_details_grid .produc_details_title_item");

      Array.from(prodDetails).reduce((_, singleProd) => {
        if (singleProd.getAttribute('product-details-title') === "frame-specs") {
          singleProd.style.display = "block";
        }
      }, null);

      let mediaList = document.querySelector(".product__column-sticky .slider-mobile-gutter .product__media-list");
      if (mediaList) {
        let listItems = mediaList.querySelectorAll(".product__media-item");
        if (window.innerWidth <= 750) {
          listItems.forEach((li, index) => {
            li.style.display = "flex";
          });
        }
      }

      if (document.querySelector(".product_option_fit")) {
          document.querySelector(".product_option_fit").style.display = "block";
          document.querySelector(".product_option_fit").nextElementSibling.style.display = "block";
          document.querySelector(".product_option_fit .product_option_values_grid").classList.add("required_field");
      }

      if (document.querySelector(".product_option_frame_color")) {
          document.querySelector(".product_option_frame_color").style.display = "block";
          document.querySelector(".product_option_frame_color").nextElementSibling.style.display = "block";
          if (document.querySelector(".product_option_frame_color .product_option_values_grid")) document.querySelector(".product_option_frame_color .product_option_values_grid").classList.add("required_field");
      }

      if (document.querySelector("li.price_breakdown.price_breakdown_frame")) document.querySelector("li.price_breakdown.price_breakdown_frame").style.display = "flex";
      if (document.querySelector(".itg_main_product_temp")) {
          document.querySelector(".itg_main_product_temp").classList.remove("replacement_localdata");
          document.querySelector(".itg_main_product_temp").classList.add("nonreplacement_localdata");
      }

      document.querySelectorAll('.product_option_frame_color .product_option_values_grid.itg_price_cal').forEach(el => el.addAttribute('data-mainprice'));

    }
});

document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") {
        let isProductPage = window.location.pathname.includes("/products/");
        if (isProductPage) {
            sessionStorage.setItem("visitedProductPage", "true");
        }
    }
});

window.addEventListener("pageshow", function () {
    if (!window.location.pathname.includes("/products/") && sessionStorage.getItem("visitedProductPage")) {
        // localStorage.removeItem("hideReplacementDataOptions");
        sessionStorage.removeItem("visitedProductPage");
    }
});


// local storage js


// Frame image change JS

document.querySelectorAll('.customize_main_product_wrapper .product_option_frame_color ul.product_option_values_grid.option_values_grid_four li').forEach(function (item) {
    item.addEventListener('click', function () {
        let lensImage = this.getAttribute('data-upc');
        let FrameImageList = document.querySelector('.customize_main_product_wrapper .frameimage_list');

        if (lensImage && lensImage.trim() !== '') {

          if (FrameImageList) {
            FrameImageList.style.display = 'flex';
          }

          let liElements = document.querySelectorAll('.customize_main_product_wrapper ul.frameimage_list li');
          let noFrameImageList = document.querySelector('.customize_main_product_wrapper .no_frameimage_list');

          let matchFound = false;

          liElements.forEach(function (li) {
            if (li.getAttribute('data-framemediaid') === lensImage) {
              li.style.display = 'block'; // Show matching li
              matchFound = true;
            } else {
              li.style.display = 'none'; // Hide other li elements
            }
          });

          // If a matching li is found, hide noFrameImageList; otherwise, show it
          noFrameImageList.style.display = matchFound ? 'none' : 'flex';
        }
    });
});


// document.addEventListener("DOMContentLoaded", function () {
//     document.querySelectorAll(".thumbnail-list__item button").forEach(button => {
//         button.addEventListener("click", function () {
//             document.querySelector(".frameimage_list").style.display = "none";
//             document.querySelector(".no_frameimage_list").style.display = "flex";
//         });
//     });
// });


document.addEventListener("DOMContentLoaded", function () {
    const frameList = document.querySelector(".frameimage_list");
    const noFrameList = document.querySelector(".no_frameimage_list");
    const galleryItems = document.querySelectorAll(".no_frameimage_list.product__media-list .product__media-item");

    document.querySelectorAll(".thumbnail-list__item button").forEach(button => {
        button.addEventListener("click", function () {
            const thumbnailImgAlt = button.getAttribute("data-img-id");

            frameList?.style.setProperty("display", "none");
            noFrameList?.style.setProperty("display", "flex");

            galleryItems.forEach(item => {
                item.classList.remove("is-active");
                item.style.display = "none";
            });

            const matchedItem = Array.from(galleryItems).find(item =>
                item.querySelector(".product__media")?.getAttribute("data-img-id") === thumbnailImgAlt
            );

            if (matchedItem) {
                matchedItem.classList.add("is-active");
                matchedItem.style.display = "block";
            }
        });
    });
});





document.addEventListener("DOMContentLoaded", function () {
    let selectedFrameColor = "";
    let selectedLensOption = "";

    function updateGallery(brandName) {
      const galleryItems = document.querySelectorAll(".no_frameimage_list.product__media-list .product__media-item");
      let foundItem = null;
      let frame = selectedFrameColor.toLowerCase().trim();
      const lens = selectedLensOption.toLowerCase().trim();
      const brand = brandName?.toLowerCase().trim() || "";

      function altMatchesParts(alt, valuesToMatch) {
        const parts = alt.toLowerCase().split(",").map(p => p.trim());
        return valuesToMatch.every(val => parts.includes(val));
      }

      // ✅ Step 1: Check for brand mismatch only if brand is provided
      let brandMismatchFallback = false;

      if (brand) {
        let brandMatchedFound = false;
        let brandCheckableImages = 0;

        for (const item of galleryItems) {
          const altText = item.querySelector("img")?.getAttribute("alt") || "";
          const parts = altText.toLowerCase().split(",").map(p => p.trim());

          if (parts.length === 3) {
            brandCheckableImages++; // only count valid images
            const altBrand = parts[2]; // assuming last is brand
            if (altBrand === brand) {
              brandMatchedFound = true;
              break; // valid brand match, skip fallback
            }
          }
        }

        if (brandCheckableImages > 0 && !brandMatchedFound) {
          console.log("Brand mismatch detected — no image matches the selected brand. Fallback to first image.");
          foundItem = galleryItems[0];
          brandMismatchFallback = true;
        }
      }


      // ✅ Step 2: Only run matching logic if no mismatch fallback occurred
      if (!brandMismatchFallback) {
        // Priority 1: match all 3 — frame, lens, brand
        for (const item of galleryItems) {
          const altText = item.querySelector("img")?.getAttribute("alt") || "";
          if (altMatchesParts(altText, [frame, lens, brand])) {
            foundItem = item;
            break;
          }
        }
        
        // Fallback: match frame + lens
        if(!document.querySelector('body.product--page.template--replacement-product')) {
          if (!foundItem) {
              for (const item of galleryItems) {
                  const altText = item.querySelector("img")?.getAttribute("alt") || "";
                  if (altMatchesParts(altText, [frame, lens])) {
                      foundItem = item;
                      break;
                  }
              }
          }
        }

        // Fallback: match brand + lens
        if(document.querySelector('body.product--page.template--replacement-product')) {
          frame = '';
          if (!foundItem) {
              for (const item of galleryItems) {
                  const altText = item.querySelector("img")?.getAttribute("alt") || "";
                  if (altMatchesParts(altText, [lens, brand])) {
                      foundItem = item;
                      break;
                  }
              }
          }
          // console.log("foundItem (brand + lens)==>>>>>",foundItem)
        }
        

        // Fallback: match frame only
        if (!foundItem) {
            for (const item of galleryItems) {
                const altText = item.querySelector("img")?.getAttribute("alt") || "";
                if (altMatchesParts(altText, [frame])) {
                    foundItem = item;
                    break;
                }
            }
        }

        // Final fallback: first image
        if (!foundItem && galleryItems.length > 0) {
          foundItem = galleryItems[0];
        }
      }
      

      // ✅ Step 3: Reset and show matched item
      galleryItems.forEach(item => {
        item.classList.remove("is-active", "showthisImg");
        item.style.display = "none";
      });

      if (foundItem) {
        foundItem.style.display = "block";
        foundItem.classList.add("is-active", "showthisImg");
        // console.log(
        //     "Final Shown Image:",
        //     foundItem.querySelector(".product__media img").getAttribute("alt") === ""
        //       ? "first Image"
        //       : foundItem.querySelector(".product__media img").getAttribute("alt")
        //   );
      }

      
    }


    // Frame Color Selection
    // document.querySelectorAll(".product_option_frame_color_data").forEach(el => {
    //   el.addEventListener("click", function () {
    //     selectedFrameColor = this.getAttribute("option-value");
    //     updateGallery("");
    //   });
    // });


    document.querySelectorAll(".product_option_frame_color .product_option_frame_color_data").forEach(el => {
        setTimeout(() => {
          if (el.classList.contains("frame_color_active")) {
            selectedFrameColor = el.getAttribute("option-value");
            updateGallery("");
          }
        }, 50)

        el.addEventListener("click", function () {
          selectedFrameColor = this.getAttribute("option-value");
          updateGallery("");
        });

    });

    // Lens Option Selection
    document.querySelectorAll(".all_brand_options").forEach(el => {
      el.addEventListener("click", function (e) {
        let brandName = el.closest('.product_option_brand_lens_content.produc_brand_option_active').getAttribute("brand-name");
        let onlyBrandName = "";
        let brandParts = brandName.split("_");

        brandParts.forEach((eachWord, index) => {
          if (index === brandParts.length - 2) {
            onlyBrandName = eachWord;
          }
        });
        selectedLensOption = this.getAttribute("option-value");
        updateGallery(onlyBrandName);
      });
    });
});




/* --------------------- custom js for vision type luxottica only and other are blocked --------------------- */

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".product_option__value.product_option_brand_value").forEach(function (item) {
        item.addEventListener("click", function (e) {
            let brandValue = item.getAttribute("option-value").toLowerCase().trim();
            if (brandValue.includes("sunberryrx")) {
                document.querySelectorAll(".vision_type_and_prescripiton_wrapper .vision_type_grid .vision_type_item").forEach((item) => { item.classList.remove("luxottica_vision_type_blocked") });
                if (document.querySelector(".SV_Pro_AvailabilityCheck")) document.querySelector(".SV_Pro_AvailabilityCheck").style.display = 'none';
            } else {
                document.querySelectorAll(".vision_type_and_prescripiton_wrapper .vision_type_grid .vision_type_item").forEach((item) => {
                    if (item.getAttribute("data-luxottica-vision") == "false") item.classList.add("luxottica_vision_type_blocked")
                })
                if (document.querySelector(".SV_Pro_AvailabilityCheck")) document.querySelector(".SV_Pro_AvailabilityCheck").style.display = 'block';
            }
        });
    });
});

/* --------------------- custom js for vision type luxottica only and other are blocked --------------------- */



//---------------------------- high_rx toggle js ---------------------

var toggleInputs = document.querySelectorAll('.high_rx_toggle input');
toggleInputs.forEach(function (toggleInput) {
    toggleInput.addEventListener('change', function () {
        if (this.checked) {
            document.querySelector('.hide_filter input').closest('label').click();
            document.querySelector('.high_rx_filter.Yes').querySelector('label').click();
        } else {
            document.querySelector('.hide_filter input').closest('label').click();
            document.querySelector('.high_rx_filter.Yes').querySelector('label').click();
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    var checkUrl = location.href;
    if (checkUrl.includes('?filter.p.m.custom.high_rx')) {
        var toggleInputs = document.querySelectorAll('.high_rx_toggle input');

        toggleInputs.forEach(function (toggleInput) {
            toggleInput.checked = true;
        });
    }
});

// --------------------- high_rx toggle js ---------------------


//---------------------- lower priced lens option order --------

// document.addEventListener("DOMContentLoaded", function () {
//   let all_brand_lens_options_container = document.querySelectorAll(".product_option_values_grid .lens_types_brand_wrapper");

//   all_brand_lens_options_container.forEach(container => {
//     let valueElements = Array.from(container.querySelectorAll(".product_option__value"));

//     let elementsWithPrice = valueElements
//       .map(el => {
//         let price = parseFloat(el.getAttribute('data-lensprice')) || 0;
//         return { el, price };
//       });

//     elementsWithPrice.sort((a, b) => a.price - b.price);

//      elementsWithPrice.forEach((item, index) => {
//         const orderIndex = index + 1; 
//         item.el.setAttribute('data-order-style', orderIndex);
//         item.el.style.order = orderIndex;
//       });
//   });
// });

//---------------------- lower priced lens option order --------



// document.addEventListener("click", function (e) {
//   console.log(e.target,"target consoled");
//   const wishlistBtn = e.target.closest(".swym-wishlist-collections-v2-container .swym-wishlist-collections-v2");
//   console.log("wishlist btn clicked");
//   if (wishlistBtn) {
//     wishlistBtn.classList.add("active");
//   }
// });


document.addEventListener("DOMContentLoaded", function () {
    // Run only on the cart page
    if (!window.location.pathname.includes("/cart")) return;

    const cartItems = document.querySelectorAll('.cart__items tr.cart-item');
    let foundEmpty = false;

    // Step 1: Check for empty data-variant-id
    cartItems.forEach(row => {
        const variantId = row.getAttribute('data-variant-id')?.trim();
        if (!variantId) {
            row.style.display = 'none';
            foundEmpty = true;
        }

    });


    // Step 2: If empty found → hide totals and reload
    if (foundEmpty) {
        const totalsSection = document.querySelector('.cart__blocks .totals');
        if (totalsSection) {
            totalsSection.style.display = 'none';
        }
        location.reload();
        return;
    }

    // Step 3: If no empty IDs, match with localStorage and update content
    cartItems.forEach(row => {
        const variantId = row.getAttribute('data-variant-id')?.trim();

        if (variantId && localStorage.getItem(variantId) !== null) {
            let matchedPrice = localStorage.getItem(variantId);

            // Update price
            const priceElement = row.querySelector('.cart-item__price-wrapper .price');
            if (priceElement) {
                priceElement.textContent = matchedPrice;
            }

            // Update product option text
            const optionElement = row.querySelector('.cart-item__details .product-option');
            if (optionElement) {
                optionElement.textContent = matchedPrice;
            }
        }

        // Remove key from localStorage after using it
        localStorage.removeItem(variantId);
    });
});